module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/collapsible-container/collapsible-container.component.scss
// module id = ./src/app/modules/common-module/components/collapsible-container/collapsible-container.component.scss
// module chunks = 9